import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { desAdminDecisionService } from './service/des-admin-decision.service'
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { CommonHelper } from '../../../../utilities/common.helper';

@Component({
  selector: 'kt-des-admin-decision',
  templateUrl: './des-admin-decision.component.html',
  styleUrls: ['./des-admin-decision.component.css']
})
export class DesAdminDecisionComponent implements OnInit {
  @ViewChild('adminDecisionForm', { static: false }) adminDecisionForm: NgForm;
  public roleList: any[] = []
  private _onDestroy = new Subject<void>();
  public applicationType: string = ''
  loader: boolean;
  showUserlist: boolean = false;
  dropdownList: any = [];
  constructor(private dialogRef: MatDialogRef<DesAdminDecisionComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private cdr:ChangeDetectorRef,
  public DesAdminDecisionService: desAdminDecisionService,
    private route: ActivatedRoute,private router:Router) { }

  ngOnInit() {

    console.log(this.data)
    this.getAdminOptions();
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept(value) {
    this.dialogRef.close(value);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.markFormsTouched(this.adminDecisionForm);
		if (this.validate(this.adminDecisionForm)) {
    this.accept(this.adminDecisionForm.value)
    }
    else return
  }
  public getUserList(user) {
    if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_ADMIN && this.data.appType.toUpperCase() == HEC_CONSTANTS.DesTaskTitles.DDApproval && this.data.type == 'back')
    {
      this.showUserlist= true
      console.log(user)
      let userId = HEC_CONSTANTS.roleList[user]
      this.loader = true;
        this.cdr.detectChanges();
        return new Promise(async (resolve, reject) => {
       await this.DesAdminDecisionService.getUserDropdown(userId).subscribe(
            (res: HecResponse) => {
              if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
                this.dropdownList = res.data;
                this.loader = false;
                this.cdr.detectChanges()
                resolve(this.dropdownList);
                this.cdr.detectChanges();
              }
            }
          )
        })
          .catch(function (error) {
            console.log(error)
          })    }
  
    else
    this.showUserlist= false

 
  }

  public getAdminOptions(): void {
    if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.LOCAL_DES_ADMIN){
    switch (this.data.appType.toUpperCase()) {
      case HEC_CONSTANTS.DesTaskTitles.ADApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsAD : HEC_CONSTANTS.SendBackOptionsAD;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DDApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsDD : HEC_CONSTANTS.SendBackOptionsDD;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DIRApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsDIR : HEC_CONSTANTS.SendBackOptionsDIR;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DGApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsDG : HEC_CONSTANTS.SendBackOptionsDG;
        break;
      case HEC_CONSTANTS.DesTaskTitles.MemberApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsMEMBER : HEC_CONSTANTS.SendBackOptionsMEMBER;
        break;
      case HEC_CONSTANTS.DesTaskTitles.EDApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardOptionsED : HEC_CONSTANTS.SendBackOptionsED;
        break;
      case HEC_CONSTANTS.DesTaskTitles.ChairmanApproval:
        this.roleList = this.data.type == 'forward' ? [] : HEC_CONSTANTS.SendBackOptionsCHAIRMAN;
        break;
    }
  }else if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_ADMIN){
    switch (this.data.appType.toUpperCase()) {
      case HEC_CONSTANTS.DesTaskTitles.ADApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardForeignOptionsAD : HEC_CONSTANTS.SendBackOptionsForeignAD;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DDApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardForeignOptionsDD : HEC_CONSTANTS.SendBackOptionsForeignDD;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DIRApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardForeignOptionsDIR : HEC_CONSTANTS.SendBackOptionsForeignDIR;
        break;
      case HEC_CONSTANTS.DesTaskTitles.DGApproval:
        this.roleList = this.data.type == 'forward' ? HEC_CONSTANTS.ForwardForeignOptionsDG : HEC_CONSTANTS.SendBackOptionsForeignDG;
        break;
      case HEC_CONSTANTS.DesTaskTitles.EDApproval:
        this.roleList = this.data.type == 'forward' ? [] : HEC_CONSTANTS.SendBackOptionsForeignED;
        break;
    }
  }
}

private markFormsTouched(form): void {
  CommonHelper.markFormGroupTouched(form);
}


public validate(f): boolean {
  if (f.status === "VALID") {
    return true;
  }
}
}

